/** URL manifest defined by docs/UI_ASSET_BUILD_CONTRACT.md. Geometry lives in art-layers.tsx. */
let assets = new Map<string, string>();
let manifestLoad: Promise<void> | undefined;
const warnedPaths = new Set<string>();

export function art(path: string): string {
  const url = assets.get(path);
  if (url !== undefined) return url;
  if (!warnedPaths.has(path)) {
    warnedPaths.add(path);
    console.warn(`[art] Missing manifest entry: ${path}. Using the original path.`);
  }
  return path;
}

export async function loadArtManifest(): Promise<void> {
  return manifestLoad ??= fetchManifest();
}

async function fetchManifest(): Promise<void> {
  try {
    const response = await fetch('/ui/assets.manifest.json', { cache: 'no-cache' });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const manifest: unknown = await response.json();
    if (!manifest || typeof manifest !== 'object' || !('version' in manifest) || manifest.version !== 1
      || !('assets' in manifest) || !manifest.assets || typeof manifest.assets !== 'object' || Array.isArray(manifest.assets)) {
      throw new Error('Invalid asset manifest');
    }
    const entries = Object.entries(manifest.assets);
    if (!entries.every((entry): entry is [string, string] => typeof entry[1] === 'string')) {
      throw new Error('Invalid asset URL');
    }
    assets = new Map(entries);
  } catch (error) {
    console.warn('[art] Could not load the asset manifest. Using original paths.', error);
  }
}
